import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { HiMenu, HiX } from "react-icons/hi";
import { IoSearchOutline } from "react-icons/io5";
import SchoolLogo from "../images/school_logo.png";
import { useAuth } from "../features/auth/AuthContext";
import CategoryMegaMenu from "./CategoryMegaMenu";

const LINKS = [
  { to: "/categories", label: "دسته‌بندی‌ها", megaMenu: true },
  { to: "/", label: "پخش زنده" },
];

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [hovering, setHovering] = useState(false);
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Close the drawer on navigation.
  useEffect(() => setMenuOpen(false), [location.pathname]);

  return (
    <nav className="absolute top-0 z-[1000] flex h-[3.8rem] w-full items-center justify-between bg-transparent p-4 text-white">
      <div className="flex">
        <button
          type="button"
          aria-label="باز کردن منو"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen(true)}
          className="flex cursor-pointer items-center md:hidden"
        >
          <HiMenu size={24} />
        </button>

        <div className="ml-3 mr-3">
          <NavLink to="/">
            <img src={SchoolLogo} alt="نوساز" className="w-[3.3rem]" />
          </NavLink>
        </div>

        <div className="mr-4 hidden items-center gap-10 text-base md:flex md:flex-row">
          {LINKS.map((link) =>
            link.megaMenu ? (
              <div
                key={link.to}
                className="relative"
                onMouseEnter={() => setHovering(true)}
                onMouseLeave={() => setHovering(false)}
              >
                <NavLink
                  to={link.to}
                  className="transition hover:text-brand"
                  onClick={() => setHovering(false)}
                >
                  {link.label}
                </NavLink>
                {hovering && (
                  <div className="absolute">
                    <CategoryMegaMenu />
                  </div>
                )}
              </div>
            ) : (
              <NavLink
                key={link.label}
                to={link.to}
                className="transition hover:text-brand"
              >
                {link.label}
              </NavLink>
            )
          )}
        </div>
      </div>

      <div className="mt-1 flex items-center gap-2 md:gap-4">
        <NavLink to="/query" aria-label="جستجو">
          <IoSearchOutline className="ml-4" size={30} />
        </NavLink>

        {isAuthenticated ? (
          <NavLink to="/Account">
            <button
              type="button"
              className="rounded border-2 border-white px-4 py-2 text-sm font-bold text-white transition hover:bg-brand"
            >
              پروفایل
            </button>
          </NavLink>
        ) : (
          <div className="inline-flex">
            <NavLink to="/Signup">
              <button
                type="button"
                className="rounded-r border-2 border-white px-4 py-2 text-base font-medium leading-6 text-white transition hover:bg-brand"
              >
                ثبت نام
              </button>
            </NavLink>
            <NavLink to="/Login">
              <button
                type="button"
                className="rounded-l border-[2.3px] border-r-0 border-white px-4 py-2 text-base font-medium leading-6 text-white transition hover:bg-brand"
              >
                ورود
              </button>
            </NavLink>
          </div>
        )}
      </div>

      {/* Mobile drawer */}
      <div
        className={`absolute right-0 top-0 w-[70%] bg-[#302e2e] text-white transition-transform duration-300 ease-in-out ${
          menuOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <button
          type="button"
          aria-label="بستن منو"
          onClick={() => setMenuOpen(false)}
          className="ml-4 mt-4 flex w-full cursor-pointer justify-end pl-4"
        >
          <HiX size={24} />
        </button>
        <div className="mr-4 flex min-h-screen flex-col items-start text-sm">
          {LINKS.map((link) => (
            <NavLink
              key={link.label}
              to={link.to}
              className="my-3 text-sm font-semibold transition hover:text-brand"
            >
              {link.label}
            </NavLink>
          ))}
          <NavLink to="/query" className="flex flex-row items-center">
            <IoSearchOutline className="mt-2" size={30} />
            <p className="mr-1 mt-1 text-sm font-semibold">جستجو</p>
          </NavLink>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
